"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneClickPurchaseButtonStyled = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const themed_button_1 = require("../themed-button");
exports.Container = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  width: 343px;
`;
exports.OneClickPurchaseButtonStyled = (0, styled_components_1.default)(themed_button_1.ThemedButton) `
  width: 100%;
  border-radius: 9999px;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
    background-color: #ccc;
    color: #000;
    border: none;
    box-shadow: none;
    outline: none;
  }
`;
